import Api from "@/services/service-v2";

export const buildConfig = (payload) =>
  Api().$http.post(
    `/cap/users/tenant/set-build-config/${payload.tenant}/${payload.type}`,
    payload.data
  );
export const buildGenerate = (payload) =>
  Api().$http.post(`/cap/users/application-build/build/generate`, payload);

export const getBuildStatus = (payload) =>
  Api().$http.get(`/cap/users/application-build/detail/${payload.id}`);

export const addWebhook = (payload) =>
  Api().$http.post(`/webhook/register-tenant`, payload);

export const addWebhookEvent = (payload) =>
  Api().$http.post(`/webhook/add-webhook-event`, payload);

export const webhookEventList = (payload) =>
  Api().$http.get(`/webhook/event-list/${payload.id}`);

export const deleteEvent = (payload) =>
  Api().$http.put(`/webhook/event-delete/${payload.id}`);

export const eventList = () => Api().$http.get(`/webhook/events.json`);
